import { render, staticRenderFns } from "./Supervise.vue?vue&type=template&id=1152c0ea"
import script from "./Supervise.vue?vue&type=script&lang=js"
export * from "./Supervise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports